import { CloudGateway } from '@shure/cloud/shared/models/devices';

import { CloudGatewayFragment } from '../graphql/generated/cloud-sys-api';

import { mapCloudGatewayManagedDeviceFromSysApi } from './map-cloud-gateway-managed-device';

export function mapCloudGatewayFromSysApi(cloudGateway?: CloudGatewayFragment | null | undefined): CloudGateway {
	return {
		canManageDevices: !!cloudGateway?.canProxy,
		maxManagedDeviceCount: cloudGateway?.maxManagedDeviceCount ?? 0,
		managedDevices: (cloudGateway?.managedDevices ?? []).map(mapCloudGatewayManagedDeviceFromSysApi)
	};
}
